import L from 'leaflet';

const shadowImage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAPCAYAAADzun+cAAAACXBIWXMAAACSAAAAkgH5vEl0AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAUhJREFUOI211F0rRFEUxvHfHIwiEVJciJIL8f2/hXu5FXmbiZDhOONir53NTGcYPLVa5639X886e6+O6dSJqIr7MsOwyE3k/OzTh5NAVRGLWI7cjZjHbLFmjQGecI9eXNcYTgJ3YrFFbGAtgN0ooHQ6bq1hETWucIL7NvBMQHaxGQVkx9OqxgWOZ1ugmziQ3M78AlZqKLXfOHCFdRxhwff3QZsavOIcp3j9Cu5IDg//ANpEvOASZ+hHASOO57CPpSmgeRNld7fSZrrCc1GIr+Dc4q0xBbXB8oKDgF1HHuDNxxn+pBLQxV7kNjVFPOAmYHdSW0eGxThlcCWd0xWjLS5d1QG4jngsXDV+oAyew07k0tWbNG16Uvt6Ugvz+1ZXk8AVVqUNlcdcX2phHnPlv5oaViqPxG1p1valVtb+wNUkMB+TKf/Pf9c7sSFsirJD4OgAAAAASUVORK5CYII=';
const outletIconOptions = {
  iconSize: [20, 36],
  shadowSize: [30, 15],
  iconAnchor: [10, 36],
  shadowAnchor: [0, 15],
  popupAnchor: [8, 30],
  shadowUrl: shadowImage,
};

// @ts-ignore
const outletAIcon = new L.Icon({
  iconUrl: '/images/markers/a.png',
  ...outletIconOptions,
});

// @ts-ignore
const outletBIcon = new L.Icon({
  iconUrl: '/images/markers/b.png',
  ...outletIconOptions,
});

// @ts-ignore
const outletCIcon = new L.Icon({
  iconUrl: '/images/markers/c.png',
  ...outletIconOptions,
});

// @ts-ignore
const outletASelectedIcon = new L.Icon({
  iconUrl: '/images/markers/a-selected.png',
  ...outletIconOptions,
});

// @ts-ignore
const outletBSelectedIcon = new L.Icon({
  iconUrl: '/images/markers/b-selected.png',
  ...outletIconOptions,
});

// @ts-ignore
const outletCSelectedIcon = new L.Icon({
  iconUrl: '/images/markers/c-selected.png',
  ...outletIconOptions,
});

// @ts-ignore
const outletIcon = new L.Icon({
  iconUrl: '/images/markers/empty.png',
  ...outletIconOptions,
});

// @ts-ignore
const outletPositiveIcon = new L.Icon({
  iconUrl: '/images/markers/empty-positive.png',
  ...outletIconOptions,
});

// @ts-ignore
const outletNegativeIcon = new L.Icon({
  iconUrl: '/images/markers/empty-negative.png',
  ...outletIconOptions,
});

// @ts-ignore
const outletSelectedIcon = new L.Icon({
  iconUrl: '/images/markers/empty-selected.png',
  ...outletIconOptions,
});

// @ts-ignore
const interestPointIcon = new L.Icon({
  iconUrl: '/images/markers/interest.png',
  ...outletIconOptions,
});

// @ts-ignore
const locationIcon = new L.Icon({
  iconUrl: '/images/markers/location.png',
  ...outletIconOptions,
});

export const markerIcons: Record<string, L.Icon<L.BaseIconOptions>> = {
  A: outletAIcon,
  B: outletBIcon,
  C: outletCIcon,
  'A-selected': outletASelectedIcon,
  'A-positive': outletASelectedIcon,
  'A-negative': outletASelectedIcon,
  'B-selected': outletBSelectedIcon,
  'C-selected': outletCSelectedIcon,
  outlet: outletIcon,
  'outlet-positive': outletPositiveIcon,
  'outlet-negative': outletNegativeIcon,
  'outlet-selected': outletSelectedIcon,
  interest: interestPointIcon,
  location: locationIcon,
};
